// src/components/JobSearchFilters.tsx
import React from 'react';
import { Tooltip } from 'antd';
import { BellOutlined, CloseOutlined, EditOutlined, EnvironmentOutlined, SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useMediaQuery } from "@uidotdev/usehooks";
import {ILocation, IPosition} from "../../../services/types.ts";
import {
    InputLabels,
    SaveFilter,
    SearchContainer,
    StyledCloseBtn,
    StyledInput
} from "candidate/src/pages/jobPool/JobPool.tsx";
import {colors} from "../../../util/colors.ts";

const InputWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 16px;
    align-items: center;
`;

interface CandidateSearchFiltersProps {
    selectedPosition: IPosition | null;
    selectedLocation: ILocation | null;
    onPositionClick: () => void;
    onLocationClick: () => void;
    onClearFilters: () => void; // Combined clear logic
    onSaveSearchClick: () => void;
    isSaveSearchDisabled: boolean;
    isSavingSearch: boolean;
}

export const CandidateSearchFilters: React.FC<CandidateSearchFiltersProps> = ({
                                                                                  selectedPosition,
                                                                                  selectedLocation,
                                                                                  onPositionClick,
                                                                                  onLocationClick,
                                                                                  onClearFilters,
                                                                                  onSaveSearchClick,
                                                                                  isSaveSearchDisabled,
                                                                                  isSavingSearch,
                                                                              }) => {
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    const handleClearClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent input click handler
        onClearFilters();
    };

    return (
        <SearchContainer>
            <InputWrapper>
                <InputLabels>Was?</InputLabels>
                <StyledInput
                    readOnly={true}
                    onClick={onPositionClick}
                    placeholder={isMobile ? "Was?" : "Alle, kein Filter"}
                    value={selectedPosition?.label ?? ''}
                    prefix={isMobile ? <SearchOutlined /> : <EditOutlined />}
                    suffix={selectedPosition && ( // Show clear only if there's a selection
                        <StyledCloseBtn
                            onClick={handleClearClick}
                            style={{ color: colors.text, backgroundColor: "white" }}
                            size="small"
                            shape="circle"
                            icon={<CloseOutlined />}
                        />
                    )}
                    size="large"
                />
            </InputWrapper>
            <InputWrapper>
                <InputLabels>Wo?</InputLabels>
                <StyledInput
                    size="large"
                    onClick={onLocationClick}
                    readOnly={true}
                    placeholder={isMobile ? "Wo?" : "Alle, kein Filter"}
                    value={selectedLocation ? `${selectedLocation.label_client}` : ''}
                    prefix={isMobile ? <EnvironmentOutlined /> : <EditOutlined />}
                    suffix={selectedLocation && ( // Show clear only if there's a selection
                        <StyledCloseBtn
                            onClick={handleClearClick}
                            style={{ color: colors.text, backgroundColor: "white" }}
                            size="small"
                            shape="circle"
                            icon={<CloseOutlined />}
                        />
                    )}
                />
            </InputWrapper>
            <Tooltip
                title={isSaveSearchDisabled ? "Wählen Sie zuerst welche Berufe oder Tätigkeiten Sie suchen, bevor Sie eine Suche speichern" : "Diese Suche als Benachrichtigung speichern"}
            >
                <SaveFilter
                    onClick={onSaveSearchClick}
                    disabled={isSaveSearchDisabled || isSavingSearch}
                    loading={isSavingSearch}
                    icon={<BellOutlined />}
                >
                    Suche speichern
                </SaveFilter>
            </Tooltip>
        </SearchContainer>
    );
};
